import type { FC, Dispatch, SetStateAction } from "react";
import {
  Loading,
  SecondaryContainer as CommonContainer,
  NewPagination,
} from "components";
import { useLocale } from "hooks";
import type { ReactPaginateProps } from "react-paginate";
import type { Props as SelectProps } from "react-select";
import NewsTabs from "./NewsTabs";
import NewsEventCard from "./NewsEventCard";
import NewsFilter from "./NewsFilter";
import translation from "../translation";

interface IProps {
  data?: {
    cmsData: Array<any>;
    page: number;
    cmsCount: number;
    eventsTagTrees: any[];
    newsTagTrees: any[];
  };
  activeTab: string;
  setActiveTab: Dispatch<SetStateAction<string>>;
  totalPagesCount: number;
  setTotalPagesCount: Dispatch<SetStateAction<number>>;
  onPageChange: ReactPaginateProps["onPageChange"];
  handleSearch: (isEmptyInput?: boolean | undefined) => Promise<void>;
  goTab: (tabKey?: string) => Promise<void>;
  loading: boolean;
  currentPage: number;
  listData: any[];
  layout?: "primary" | "secondary";
  tabOptions?: SelectProps["options"];
  tabs?: any[];
  mappedTabs: any;
}

const NewsListComponent: FC<IProps> = ({
  data,
  activeTab,
  setActiveTab,
  totalPagesCount,
  onPageChange,
  goTab,
  loading,
  handleSearch,
  currentPage,
  listData,
  layout = "primary",
  tabOptions,
  tabs = [],
  mappedTabs = {},
}) => {
  const { locale } = useLocale();
  return (
    <div className="tw-pb-[30px]">
      <div className="tw-border-solid tw-border-x-0 tw-border-t-0 tw-border-b-0 md:tw-border-b tw-border-b-[#344456]/5">
        <CommonContainer>
          {layout === "primary" ? (
            <div className="tw-flex tw-flex-col lg:tw-flex-row tw-justify-between tw-w-full tw-px-4 md:tw-px-0">
              <NewsTabs
                layout={layout}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                goTab={goTab}
                tabOptions={tabOptions}
                tabs={tabs}
                mappedTabs={mappedTabs}
              />
              <NewsFilter
                activeTab={activeTab}
                handleSearch={handleSearch}
                data={data}
              />
            </div>
          ) : (
            <div className="tw-grid tw-grid-cols-5 tw-gap-x-2 tw-px-4 md:tw-px-0">
              <NewsTabs
                layout={layout}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                goTab={goTab}
                tabOptions={tabOptions}
                tabs={tabs}
                mappedTabs={mappedTabs}
              />
              <NewsFilter
                parentOptions={tabOptions}
                activeTab={activeTab}
                handleSearch={handleSearch}
                data={data}
                layout={layout}
                goTab={goTab}
              />
            </div>
          )}
        </CommonContainer>
      </div>
      <CommonContainer>
        {loading ? (
          <div className="tw-min-h-[200px] tw-flex tw-items-center tw-justify-center loading">
            <Loading />
          </div>
        ) : (
          <div className="tw-px-4 md:tw-px-0">
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-[30px] tw-my-[50px]">
              {listData?.length > 0 &&
                listData?.map?.((item) => (
                  <NewsEventCard
                    item={item}
                    key={item?.id}
                    activeTab={activeTab}
                  />
                ))}
            </div>
            {(!listData?.length || listData?.length === 0) && (
              <div className="tw-text-center tw-min-h-[100px]">
                {translation[locale]?.NOT_FOUND}
              </div>
            )}
            {totalPagesCount !== 0 && (
              <NewPagination
                currentPage={currentPage}
                onPageChange={onPageChange}
                totalPagesCount={totalPagesCount}
              />
            )}
          </div>
        )}
      </CommonContainer>
    </div>
  );
};

export default NewsListComponent;
